module.exports = __webpack_public_path__ + "media/images/projects/1-dashboard-6218a4154ba63c3e16b2d842e8d750c3.jpg";